module.exports = __webpack_public_path__ + "img/soot.c73236e2.png";